import type { CollectionId } from "@anaconda/core/nft-collection/types"
import type { ActivityId } from "@rarible/types"
import type { Blockchain } from "../blockchain/types"
import type { PriceValue } from "../price/types"

export enum FeeType {
  FLAT = "FLAT",
  PERCENTAGE = "PERCENTAGE",
}

export interface Fee {
  type: FeeType
  amount: number
}

export enum DropType {
  // initial POC implementation of drops
  V0 = "v0",
  Thirdweb = "thirdweb",
  MultiChain = "multichain",
}

export enum DropStatus {
  Upcoming = "upcoming",
  Minting = "minting",
  Ended = "ended",
  OverSupply = "ended",
}

export enum DropPreviewType {
  Image = "image",
  Video = "video",
  ThreeD = "3d",
}

export interface DropMedia {
  type: DropPreviewType
  url: string
}

export enum DropPhaseType {
  Allowlist = "allowlist",
  Public = "public",
}

export interface DropPhasePerChain {
  blockchain: Blockchain
  collectionAddress?: CollectionId
  price: PriceValue
  fee?: PriceValue
}

export interface DropPhase {
  price: PriceValue
  startDate: string
  endDate?: string
  maxMintPerWallet?: number
  type: DropPhaseType
  maxClaimableSupply?: number
  pricesPerChain?: DropPhasePerChain[]
  name?: string
}

export interface DropUserClaimLimitInfo {
  limitPerWallet: number
  alreadyMinted: number
  remainingLimit: number
}

export interface Drop {
  id: CollectionId
  type: DropType
  title: string
  description: string
  blockchain: Blockchain
  media: DropMedia
  totalSupply?: number
  minted?: number
  isVerified: boolean
  maxMintPerWallet?: number
  author: string
  tokenStandard?: string
  phases: DropPhase[]
  fees: Fee[]
  twitterLink?: string
}

export interface MinimalDrop {
  id: CollectionId
  type: DropType
  title: string
  blockchain: Blockchain
  media: DropMedia
  totalSupply?: number
  maxMintPerWallet?: number
  description: string
  author: string
  tokenStandard?: string
  phases: DropPhase[]
  fees: Fee[]
  twitterLink?: string
  isVerified: boolean
}

export interface DropActivity {
  id: ActivityId
  minter: string
  price: PriceValue
  quantity: number
  time: string
}
